import SettingFrame from "../../../../components/@settings/SettingFrame";
import UpdateShippingRate from "../../../../components/@shipping/shipping_rates/UpdateShippingRate";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ShippingRateUpdatePage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <UpdateShippingRate
                routeType={routeType}
            />
        </SettingFrame>
    )
}       